import React from "react"
import PropTypes from "prop-types"
import {Icon, Tree} from "antd"
import {LoadingIndicator} from "../../util/Util";

const TreeNode = Tree.TreeNode;
const mapTreeNode = (type) => <TreeNode title={type} key={type}/>;

const OverviewTree = ({fetchingOverview, overview, handleTypeChange, selectedType}) => {
    
    const mapEntity = entity => overview[entity].map(type => mapTreeNode(type));
    
    const makeEntityNode = (key, title, icon) => <TreeNode title={<span><Icon type={icon}/> {title}</span>} key={key}>
        {mapEntity(key)}
    </TreeNode>;
    
    return <LoadingIndicator loading={fetchingOverview}>
        <Tree onSelect={handleTypeChange} selectedKeys={[selectedType]} defaultExpandAll={true}>
            {makeEntityNode('person', 'Person', 'user')}
            {makeEntityNode('site', 'Site', 'home')}
            {makeEntityNode('link', 'Link', 'link')}
        </Tree>
    </LoadingIndicator>
};

OverviewTree.propTypes = {
    fetchingOverview: PropTypes.bool.isRequired,
    overview: PropTypes.object.isRequired,
    handleTypeChange: PropTypes.func.isRequired,
    selectedType: PropTypes.string
};

export default OverviewTree


// WEBPACK FOOTER //
// ./src/js/lovs/manage/OverviewTree.js